import {
    defaultBaseQuery,
    transformErrorResponse,
    transformSuccessResponse,
    buildFormData
} from '@/services';
import { createApi } from '@reduxjs/toolkit/query/react';

const companyApi = createApi({
    baseQuery: defaultBaseQuery,
    reducerPath: 'companyApi',
    endpoints: (builder) => ({

        addCompany: builder.mutation({
            query: ({ data, logo, certificate }) => ({
                url: '/placements/company',
                method: 'POST',
                // data goes as a JSON string field (not a Blob), logo / certificate as the file binaries
                body: buildFormData({ data: JSON.stringify(data), logo, certificate })
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        updateCompany: builder.mutation({
            query: ({ companyId, data, logo, certificate }) => ({
                url: `/placements/company/${companyId}`,
                method: 'PUT',
                // Same as add — data as a JSON string field, logo / certificate as the file binaries;
                // an unchanged logo / certificate still goes as an empty field (buildFormData drops null)
                body: buildFormData({ data: JSON.stringify(data), logo: logo ?? "", certificate: certificate ?? "" })
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getListCompany: builder.query({
            query: ({ page = 0, size = 10, searchText = '', sortBy = '', sortDir = '' } = {}) => ({
                url: `/placements/company`,
                method: 'GET',
                params: {
                    page, size, ...(searchText && { searchText }),
                    ...(sortBy && { sortBy }), ...(sortDir && { sortDir })
                }
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getCompanyById: builder.query({
            query: (companyId) => ({
                url: `/placements/company/${companyId}`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        deleteCompany: builder.mutation({
            query: (companyId) => ({
                url: `/placements/company/${companyId}`,
                method: 'DELETE'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
    })
});

export const {
    useAddCompanyMutation, useUpdateCompanyMutation,
    useLazyGetListCompanyQuery, useLazyGetCompanyByIdQuery,
    useDeleteCompanyMutation
} = companyApi;

export default companyApi;
